abstract class ListenerCollection<T> {
   protected readonly listeners: T[] = [];

   listen = (listener: T) => {
       this.listeners.push(listener);
   };

   unlisten = (listener: T) => {
       this.listeners.splice(this.listeners.indexOf(listener), 1);
   };

   update = (props: any) => {};
}

export default ListenerCollection;